import { render, staticRenderFns } from "./totalMessagesPerChannel.vue?vue&type=template&id=3b02102d&scoped=true&"
import script from "./totalMessagesPerChannel.vue?vue&type=script&lang=js&"
export * from "./totalMessagesPerChannel.vue?vue&type=script&lang=js&"
import style0 from "./totalMessagesPerChannel.vue?vue&type=style&index=0&id=3b02102d&scoped=true&lang=css&"
import style1 from "./totalMessagesPerChannel.vue?vue&type=style&index=1&lang=scss&"
import style2 from "@/assets/css/bs-helpers.css?vue&type=style&index=2&id=3b02102d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b02102d",
  null
  
)

export default component.exports